<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Out of My Later Years</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ct" style="margin-top: 5em;"><a href="#/contents#tahir0002" id="tahir002">Convictions and Beliefs</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3366c0d4